// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"936":"4f4b7480","3259":"31947cdc","5771":"7cdb7c29","5895":"3d18a92e","6431":"3a331e4d","6878":"0e29f8c7","9696":"b56ce4e1"}[chunkId] + ".chunk.css";
};